/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef, useEffect } from 'react'
import { useGLTF } from '@react-three/drei'
import { useCameraControls, selectRadius, MAX_RADIUS } from './CameraControls';
import { useThree } from '@react-three/fiber';

const MIN_RADIUS = 20;

export default function Model({ ...props }) {
  const group = useRef()
  const { nodes, materials } = useGLTF('./gltf/glovebox.glb')
  const { scene } = useThree();

  const radius = useCameraControls(selectRadius);

  useEffect(() => {
    const t = (Math.max(radius, MIN_RADIUS)-MIN_RADIUS)/(MAX_RADIUS-MIN_RADIUS);

    materials.WindowMaterial.transparent = true;
    materials.WindowMaterial.opacity = .2*t;

    materials.BoxMaterial.transparent = true;
    materials.BoxMaterial.opacity = t+(1-t)*.1;

    materials.GloveRingMaterial.transparent = true;
    materials.GloveRingMaterial.opacity = t+(1-t)*.1;

    materials.GloveRubberMaterial.transparent = true;
    materials.GloveRubberMaterial.opacity = t+(1-t)*.1;

    materials.LeftGloveRingMaterial.transparent = true;
    materials.LeftGloveRingMaterial.opacity = t+(1-t)*.1;

    materials.LeftGloveRubberMaterial.transparent = true;
    materials.LeftGloveRubberMaterial.opacity = t+(1-t)*.1;
  }, [ radius, materials ]);

  return (
    <group ref={group} {...props} dispose={null}>
      <group position={[7.07, -6.53, -7.81]} rotation={[-Math.PI, 1.57, 0]} scale={39.37}>
        <mesh renderOrder={10} geometry={nodes.rightGloveMesh.geometry} material={materials.GloveRingMaterial} />
        <mesh renderOrder={10} geometry={nodes.rightGloveMesh_1.geometry} material={materials.GloveRubberMaterial} />
      </group>
      <group position={[36.62, -6.53, -7.78]} rotation={[-Math.PI, 1.57, 0]} scale={39.37}>
        <mesh renderOrder={10} geometry={nodes.rightGloveMesh.geometry} material={materials.GloveRingMaterial} />
        <mesh renderOrder={10} geometry={nodes.rightGloveMesh_1.geometry} material={materials.GloveRubberMaterial} />
      </group>
      <group position={[-22.45, -6.53, -7.81]} rotation={[-Math.PI, 1.57, 0]} scale={39.37}>
        <mesh renderOrder={10} geometry={nodes.rightGloveMesh.geometry} material={materials.GloveRingMaterial} />
        <mesh renderOrder={10} geometry={nodes.rightGloveMesh_1.geometry} material={materials.GloveRubberMaterial} />
      </group>
      <group position={[-5.08, -6.5, -7.76]} rotation={[-Math.PI, -Math.PI / 2, 0]} scale={39.37}>
        <mesh renderOrder={10} geometry={nodes.leftGloveMesh.geometry} material={materials.LeftGloveRingMaterial} />
        <mesh renderOrder={10} geometry={nodes.leftGloveMesh_1.geometry} material={materials.LeftGloveRubberMaterial} />
      </group>
      <group position={[-34.61, -6.5, -7.76]} rotation={[-Math.PI, -Math.PI / 2, 0]} scale={39.37}>
        <mesh renderOrder={10} geometry={nodes.leftGloveMesh.geometry} material={materials.LeftGloveRingMaterial} />
        <mesh renderOrder={10} geometry={nodes.leftGloveMesh_1.geometry} material={materials.LeftGloveRubberMaterial} />
      </group>
      <group position={[24.45, -6.5, -7.76]} rotation={[-Math.PI, -Math.PI / 2, 0]} scale={39.37}>
        <mesh renderOrder={10} geometry={nodes.leftGloveMesh.geometry} material={materials.LeftGloveRingMaterial} />
        <mesh renderOrder={10} geometry={nodes.leftGloveMesh_1.geometry} material={materials.LeftGloveRubberMaterial} />
      </group>
      <mesh renderOrder={20} geometry={nodes.GloveBox_1.geometry} material={materials.BoxMaterial} />
      <mesh renderOrder={20} geometry={nodes.GloveBox_2.geometry}>
        <meshPhysicalMaterial clearcoat={1} sheen={1} metalness={0} roughness={.1} envMap={scene.envMap} color={0xffffff} transparent={true} opacity={.2}/>
      </mesh>

      <mesh geometry={nodes.mesh0.geometry} material={materials.InnerFaceMaterial} />
      <mesh geometry={nodes.mesh0_1.geometry} material={materials.RedMaterial} />
      <mesh geometry={nodes.mesh0_2.geometry} material={materials.HandleMaterial} />
      <mesh geometry={nodes.mesh0_3.geometry} material={materials.MainPanelMaterial} />
      <mesh geometry={nodes.mesh0_4.geometry} material={materials.BaseMaterial} />

      <mesh geometry={nodes.Robot.geometry} material={materials.RobotMaterial} />

    </group>
  )
}
